import React from 'react';
import OrderWithCurrentVersion from '../../../models/order-entry/OrderWithCurrentVersion';
import {MobileOrderHistoryOrderItem} from './MobileOrderHistoryOrderItem';

export const MobileOrderHistoryOrderList = ({orders, landscape, onUpdateOrder}: {orders: OrderWithCurrentVersion[], landscape: boolean, onUpdateOrder: Function}) => {
  return(<div className='mobile-order-history-orders-list'>
    {orders.length > 0 ? orders.map((orderVersion: OrderWithCurrentVersion) => <MobileOrderHistoryOrderItem key={orderVersion.orderId} orderVersion={orderVersion} landscape={landscape} onUpdateOrder={onUpdateOrder}/>)
      : 'no orders to display'}
  </div>);
};